module.exports = __webpack_public_path__ + "static/media/svg-8.d4ec9e63.svg";